import { CanMatchFn, UrlSegment } from '@angular/router';
import { canLockArea } from '@theme/areas/areas';

/**
 * `/dashboard/<area>` exists for every area but Start, which uses `/dashboard` itself. Areas
 * without rights show the locked page 2a there; Verwaltung has only that page, the component
 * sends users with rights to the area's pages.
 */
export const areaDashboardGuard: CanMatchFn = (_route, segments: UrlSegment[]) =>
  canLockArea(segments[1]?.path ?? '');
